import { openAuthMiniApp } from 'dingtalk-design-libs/biz/openAuthMiniApp'
import * as dd from 'dingtalk-jsapi'

const DING_CORP_ID = 'dinga6805fbf6e10c1a535c2f4657eb6378f'
const DING_CLIENT_ID = 'dingffhgfw0fv1lz8uc6'

function createDingAuthError(message, code, originalError) {
  const error = new Error(message)
  error.code = code
  error.originalError = originalError
  return error
}

/**
 * 判断当前页面是否运行在钉钉客户端中。
 */
export function isInDingTalk() {
  return dd.env.platform !== 'notInDingTalk'
}

/**
 * 获取当前钉钉用户的一次性授权 Code。
 * 该方法只负责钉钉侧认证，不负责 CRM Token 的保存与跳转。
 */
export function requestDingAuthCode() {
  return new Promise((resolve, reject) => {
    if (!isInDingTalk()) {
      reject(createDingAuthError('当前环境不支持钉钉自动登录', 'DING_NOT_AVAILABLE'))
      return
    }

    let settled = false
    const resolveOnce = code => {
      if (settled) return
      settled = true
      if (!code) {
        reject(createDingAuthError('未获取到钉钉授权码', 'DING_CODE_EMPTY'))
        return
      }
      resolve(code)
    }
    const rejectOnce = (message, code, error) => {
      if (settled) return
      settled = true
      reject(createDingAuthError(message, code, error))
    }

    if (typeof dd.error === 'function') {
      dd.error(error => {
        rejectOnce('钉钉环境初始化失败，请使用密码登录', 'DING_READY_ERROR', error)
      })
    }

    dd.ready(() => {
      openAuthMiniApp({
        panelHeight: 'percent75',
        path: 'pages/home/home',
        extraData: {
          clientId: DING_CLIENT_ID,
          rpcScope: 'Contact.User.Read',
          fieldScope: 'Contact.User.mobile',
          type: 0,
          ext: JSON.stringify({}),
          from: ''
        }
      })
        .then(() => {
          dd.runtime.permission.requestAuthCode({
            corpId: DING_CORP_ID,
            onSuccess: info => resolveOnce(info && info.code),
            onFail: error => {
              rejectOnce('获取钉钉授权码失败，请使用密码登录', 'DING_CODE_ERROR', error)
            }
          })
        })
        .catch(error => {
          rejectOnce('钉钉授权失败，请使用密码登录', 'DING_AUTH_ERROR', error)
        })
    })
  })
}
